export const initialDataQuotation = {
    safaris: 1,
    travelers: 1,
    stay_category_id: '',
    start_date: '',
    end_date: '',
    park_id: '',
    addional_notes: '',
    partner_selling_price: ''
};

export const initialErrorsQuotation = {
    safaris: '',
    travelers: '',
    stay_category_id: '',
    start_date: '',
    end_date: '',
    park_id: '',
    addional_notes: '',
    partner_selling_price: ''
};
